// window.btnLoading = false
import { _query } from '../utils/query.js'

export function loading(desktopRatio, mobileRatio) {
	return `<div class="loading-wrapper AspectRatio" style="--aspect-ratio:${desktopRatio};--aspect-ratio-mobile:${mobileRatio};">
    <div class="loading-icon-figure"><img src="/theme2/assets/img/default-loading.svg"></div>
  </div>`
}

export function btnLoadingStart(btn) {
	const btnDom = _query(btn)
	if (btnDom && !btnDom.classList.contains('btn--loading')) btnDom.classList.add('btn--loading')
}

export function btnLoadingDone(btn) {
	const btnDom = _query(btn)
	if (btnDom && btnDom.classList.contains('btn--loading')) btnDom.classList.remove('btn--loading')
}

export function addBtnLoading() {
	$.each($('.Btn-Loading'), (i, v) => {
		const hrefLink = $(v).attr('data-href')

		$(v).click(e => {
			e.preventDefault()
			$(v).addClass('btn--loading')
			// btnLoadingStart(v)

			window.location.href = hrefLink
		})
	})
}

window.btnLoadingDone = btnLoadingDone
window.btnLoadingStart = btnLoadingStart
